import Router from 'next/router'
import { Cookie, removeCookie } from '../utils/cookie'

export const logout = () => {
  removeCookie(Cookie.ACCESS_TOKEN)
  Router.push('/login')
}